import {HprimResolver} from "./hprim.resolver";
import {ReemissionResolver} from "./reemission.resolver";
import {DocumentTelechargementComponent} from "./pages/document/document-telechargement.component";
import {NotificationNumberResolver} from "./notification.resolver";
import {PlanifierAlerteModal} from "./pages/planifier-alerte-modal/planifier-alerte.modal";
import {ListDocumentsComponent} from "./pages/detail-resultat/list-documents/list-documents.component";
import {FacturationDetailResultatComponent} from "./pages/detail-resultat/body/facturation/facturation-detail-resultat.component";
import {BodyHorizontalTableComponent} from "./pages/detail-resultat/body/horizontal-table/body-horizontal-table.component";
import {BodyVerticalTableComponent} from "./pages/detail-resultat/body/vertical-table/body-vertical-table.component";
import {HistoriqueDossierComponent} from "./pages/detail-resultat/entete/historique/historique-dossier.component";
import {BodyDetailServeurResultatsComponent} from "./pages/detail-resultat/body/body-detail-resultat.component";
import {EnteteDetailServeurResultatsComponent} from "./pages/detail-resultat/entete/entete-detail-resultat.component";
import {ActionDetailServeurResultatsComponent} from "./pages/detail-resultat/action/action-detail-resultat.component";
import {DetailServeurResultatsComponent} from "./pages/detail-resultat/detail-resultat.component";
import {AjoutFiltreDialogComponent} from "./pages/serveur-resultats/filtres/vos-filtres/ajout-modal/ajout.modal";
import {UtilisateurPreferencesServeurResultatsResolver} from "./pages/serveur-resultats/utilisateur-preferences-serveur-resultats.resolver";
import {ServeurResultatsSelectionFiltresComponent} from "./pages/serveur-resultats/filtres/selection-filtres/selection-filtres.component";
import {ServeurResultatsVosFiltresComponent} from "./pages/serveur-resultats/filtres/vos-filtres/vos-filtres.component";
import {ServeurResultatsFiltresComponent} from "./pages/serveur-resultats/filtres/serveur-resultats-filtres.component";
import {ServeurResultatsResultatsComponent} from "./pages/serveur-resultats/resultats/serveur-resultats-resultats.component";
import {ServeurResultatsComponent} from "./pages/serveur-resultats/serveur-resultats.component";
import {NgModule} from "@angular/core";
import {RouterModule, Routes} from "@angular/router";
import {CerbaCommonModule} from "@common/cerba-common.module";
import {EnsureUserAuthGuard, LogoutAuthGuard} from "@digicerba/common";
import {CerbaPageComponent} from "./cerba.component";
import {HeaderComponent} from "./header/header.component";
import {ExamensResolver} from "app/pages/cerba/pages/serveur-resultats/examens.resolver";
import {DetailServeurResultatsResolver} from "app/pages/cerba/pages/detail-resultat/detail-resultat.resolver";
import {AccessResolver} from "./check.resolver";
import {DebounceResolver} from "./pages/serveur-resultats/filtres/debounce.resolver";
import { NotificationModuleResolver } from "./modal-notification-module/notification-module.resoler";
import { NotificationModuleComponent } from "./modal-notification-module/notification-module.component";
import { ProfilValideResolver } from "./profil-valide.resolver";
import {PopinCompleterDossierComponent} from "./pages/popin/popin-completer-dossier.component";
import {AnalyseDetailResultatComponent} from "./pages/detail-resultat/body/analyse/analyse-detail-resultat.component";
import {EmissionHprimDebounceResolver} from "./emission-hprim-debounce-resolver";

const cerbaRoutes: Routes = [
  {
    path: 'cerba',
    component: CerbaPageComponent,
    canActivate: [EnsureUserAuthGuard],
    resolve: {
      check: AccessResolver,
      nbAlerts: NotificationNumberResolver,
      notifmodule: NotificationModuleResolver,
      profilValide: ProfilValideResolver,
    },
    children: [{
      path: 'serveur-resultats',
      component: ServeurResultatsComponent,
      resolve: {
        utilisateurPreferences: UtilisateurPreferencesServeurResultatsResolver,
        emissionHprimDebounceExamen: EmissionHprimDebounceResolver
      }
    },
    {
      path: "detail-resultat/:id",
      component: DetailServeurResultatsComponent,
      resolve: {
        dossier: DetailServeurResultatsResolver,
        hprimEnabled: HprimResolver,
        reemissionEnabled: ReemissionResolver
      }
    },

      {path: '', redirectTo: 'serveur-resultats', pathMatch: 'full'}]
  },
  {
    path: "document",
    component: DocumentTelechargementComponent
  },
  { path: 'logout', component: CerbaPageComponent, canActivate: [LogoutAuthGuard] },
  { path: '', redirectTo: 'cerba', pathMatch: 'full' }
];

@NgModule({
  declarations: [
    HeaderComponent,
    CerbaPageComponent,
    ServeurResultatsComponent,
    ServeurResultatsResultatsComponent,
    ServeurResultatsFiltresComponent,
    ServeurResultatsVosFiltresComponent,
    ServeurResultatsSelectionFiltresComponent,
    DetailServeurResultatsComponent,
    AjoutFiltreDialogComponent,
    ActionDetailServeurResultatsComponent,
    EnteteDetailServeurResultatsComponent,
    BodyDetailServeurResultatsComponent,
    HistoriqueDossierComponent,
    BodyVerticalTableComponent,
    BodyHorizontalTableComponent,
    FacturationDetailResultatComponent,
    AnalyseDetailResultatComponent,
    PlanifierAlerteModal,
    ListDocumentsComponent,
    DocumentTelechargementComponent,
    NotificationModuleComponent,
    PopinCompleterDossierComponent
  ],
  entryComponents: [AjoutFiltreDialogComponent, PlanifierAlerteModal,NotificationModuleComponent, PopinCompleterDossierComponent],
  imports: [
    CerbaCommonModule,
    RouterModule.forRoot(cerbaRoutes, { useHash: true }),
  ],
  exports: [
    RouterModule,
    PopinCompleterDossierComponent
  ],
  providers: [
    AccessResolver, DetailServeurResultatsResolver, UtilisateurPreferencesServeurResultatsResolver, ExamensResolver,
    NotificationNumberResolver, HprimResolver, ReemissionResolver, DebounceResolver, NotificationModuleResolver,
    ProfilValideResolver, EmissionHprimDebounceResolver
  ]
})
export class CerbaRoutingModule {
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-serveur-resultats/digicerba-serveur-resultats-web/src/angular/cerba/src/app/pages/cerba/cerba.router.ts